import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { onboardingProgressReducers, onboardingProgressWatchers } from './progress/index';

export const coreOnboardingReducers = combineReducers({
	progress: onboardingProgressReducers
});

export const coreOnboardingWatchers = combineAllWatchers([
	onboardingProgressWatchers
]);
